import { render, staticRenderFns } from "./sort_custom.vue?vue&type=template&id=5fc85bba&scoped=true&"
import script from "./sort_custom.vue?vue&type=script&lang=js&"
export * from "./sort_custom.vue?vue&type=script&lang=js&"
import style0 from "./sort_custom.vue?vue&type=style&index=0&id=5fc85bba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc85bba",
  null
  
)

export default component.exports